import { render, staticRenderFns } from "./TableStack.vue?vue&type=template&id=2a8a7a00&scoped=true&"
import script from "./TableStack.vue?vue&type=script&lang=js&"
export * from "./TableStack.vue?vue&type=script&lang=js&"
import style0 from "./TableStack.vue?vue&type=style&index=0&id=2a8a7a00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8a7a00",
  null
  
)

export default component.exports